export const DB_NAME = "MULTIPLACER-PROD";
export const CLUSTER_NAME = "mcbim";

export const HOTKEYS = {
  SNAP_TO_GRID: "alt+s",
  TRUE_SIZE: "alt+d",
  DELETE_PRODUCT: "backspace",
  COPY_PRODUCT_TO_CLIPBOARD: "ctrl+c",
  PASTE_PRODUCT: "ctrl+v",
  ROTATE_PRODUCT: "ctrl+r",
  ABORT: "esc",
  MEASURE: "ctrl+w",
};

export const LOCAL_STORAGE_KEYS = {
  FILE_FLOOR_JOB: "fileFloorJob",
};
